import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/app.css";
import { App } from "./App.tsx";
import { CryptoSelfTest } from "./dev/cryptoSelfTest.tsx";

const host = document.getElementById("root");
if (!host) throw new Error("找不到 #root");
const cryptoTest = location.search.includes("cryptotest=1");
createRoot(host).render(
  <StrictMode>
    {cryptoTest ? <CryptoSelfTest /> : <App />}
  </StrictMode>,
);
